export default __webpack_public_path__ + "static/media/theorem-logo-large.97531be5.png";